

export const FETCH_PROPERTY_GENERAL_REQUEST = 'dashboard/FETCH_PROPERTY_GENERAL_REQUEST';
export const FETCH_PROPERTY_GENERAL_SUCCESS = 'dashboard/FETCH_PROPERTY_GENERAL_SUCCESS';
export const FETCH_PROPERTY_GENERAL_FAILURE = 'dashboard/FETCH_PROPERTY_GENERAL_FAILURE';

export const FETCH_BUSINESS_GENERAL_REQUEST = 'dashboard/FETCH_BUSINESS_GENERAL_REQUEST';
export const FETCH_BUSINESS_GENERAL_SUCCESS = 'dashboard/FETCH_BUSINESS_GENERAL_SUCCESS';
export const FETCH_BUSINESS_GENERAL_FAILURE = 'dashboard/FETCH_BUSINESS_GENERAL_FAILURE';

export const UPDATE_FIELD = 'dashboard/UPDATE_FIELD';
export const SET_DEFAULT_DATA = 'dashboard/SET_DEFAULT_DATA';
